import React, { useMemo } from 'react';
import { useCallback } from 'react';
import { useController } from 'react-hook-form';
import Checkbox from '../Checkbox';
import Radio from '../Radio';
import {
  FormInputLabel,
  FormInputRadioRow,
  FormItemContainer,
} from '../StyledComponents';

// A prop radio é inicialmente true, então caso queira um grupo de checkboxes, passar radio={false} como prop

// A props "values" recebe um array de (1 ou mais) objetos,
// com as informações do radio input por props: defaultName e defaultValueProp

const RadioOrCheckboxGroup = ({
  name,
  control,
  rules,
  title,
  isBold = false,
  onChangeDefault,
  radio = true,
  values,
  defaultName,
  fontSize = '',
  marginTop = '',
  columnGap,
  defaultValueProp,
  notRequired = false,
  requiredColor = '#0061C6',
  marginRight = '10px',
    disabled = false
}) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ control, name, rules });

  const renderError = useMemo(() => {
    return error && error.message ? (
      <p
        style={{
          color: error?.message ? '#F5365C' : '#000000',
        }}
      >
        {error?.message}
      </p>
    ) : null;
  }, [error]);

  const handleCheckbox = useCallback(
    (item) => {
      const hasValue = value?.find(
        (i) => i[defaultValueProp] === item[defaultValueProp]
      );
      const defaultValue = value || [];
      const valueToChange = hasValue
        ? value?.filter((i) => i[defaultValueProp] !== item[defaultValueProp])
        : [...defaultValue, item];
      onChange(valueToChange);
    },
    [value, onChange, defaultValueProp]
  );

  const renderItems = useMemo(() => {
    return (
      <FormInputRadioRow columnGap={columnGap ?? '44px'}>
        {values?.map((item, idx) =>
          radio ? (
            <Radio
              disabled={item?.disabled || disabled}
              marginRight={marginRight}
              key={`${idx}`}
              {...{ name, control, rules, onChangeDefault }}
              placeholder={item.placeholder}
              checked={item.value === value}
              value={item.value}
              fontSize={fontSize}
              marginTop={marginTop}
            />
          ) : (
            <Checkbox
              disabled={disabled}
              key={`${idx}`}
              {...{ name, control, rules, onChangeDefault }}
              placeholder={item[defaultName]}
              checked={value?.find(
                (i) => i[defaultValueProp] === item[defaultValueProp]
              )}
              value={item}
              onChange={handleCheckbox}
              marginRight={marginRight}
            />
          )
        ) || <div />}
      </FormInputRadioRow>
    );
  }, [
      disabled,
    control,
    name,
    onChangeDefault,
    rules,
    value,
    values,
    radio,
    handleCheckbox,
    defaultName,
    defaultValueProp,
    columnGap,
    fontSize,
    marginTop,
    marginRight,
  ]);

  return (
    <FormItemContainer>
      <FormInputLabel>
        <label style={{ fontWeight: !!isBold ? 'bold' : 'normal' }}>
          {title}{' '}
          {!notRequired && <strong style={{ color: requiredColor }}>*</strong>}
        </label>
      </FormInputLabel>
      {renderItems}
      {renderError}
    </FormItemContainer>
  );
};

export default RadioOrCheckboxGroup;
